/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState, useEffect, lazy, Suspense } from "react";
import parse from 'html-react-parser';
import './Banner.css';
import { isMobileOrTablet } from "../../components/Utils";
import { Container, Button, Spinner } from "react-bootstrap";
import BorrowerLeadFormModal from "../../commoncomponents/BorrowerLeadFormModal/borrowerleadformmodal";
 

function Banner({ data }) {

  const {
    bannerDesignMobile,
    backgroundVideoMobile,
    backgroundVideo,
    headings,
    todaysRatesTitle,
    bannerDesign,
    ctaPrimaryButton,
    ctaSecondaryButton,
    bannerText,
    ratesConfig // This should be passed from the parent component
  } = data;


  // Modal states for BorrowerLeadFormModal
  const [showLeadFormModal, setShowLeadFormModal] = useState(false);
  const [formHeading, setFormHeading] = useState("");
  const [loanPurpKeyword, setLoanPurpKeyword] = useState("");
  const [noteRate, setNoteRate] = useState("");
  const [offerTerm, setOfferTerm] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Use the same image names for video sources
  const videoSourceDesktop = backgroundVideo ? backgroundVideo.replace(/\.[^/.]+$/, ".mp4") : null;
  const videoSourceMobile = backgroundVideoMobile ? backgroundVideoMobile.replace(/\.[^/.]+$/, ".mp4") : null;

  const selectBannerDesign = isMobileOrTablet() ? bannerDesignMobile : bannerDesign;

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleCloseLeadFormModal = () => {
    setShowLeadFormModal(false);
  };

  const handleApplyNow = () => {
    setFormHeading("Apply Now");
    setLoanPurpKeyword("PURCHASE");
    setNoteRate("");
    setOfferTerm("");
    setShowLeadFormModal(true);
  };

 
  return (
    <div className="product-banner">
      {/* Video Background */}
      {windowWidth > 991.9 ? (
        videoSourceDesktop && (
          <video autoPlay muted loop playsInline id="banner-video-desktop" className="banner-video banner-deskvideo">
            <source src={`${process.env.REACT_APP_LOANPROGRAMS_URL}${videoSourceDesktop}`} loading="eager" type="video/mp4" />
          </video>
        )
      ) : (
        videoSourceMobile && (
          <video autoPlay muted loop playsInline id="banner-video-mobile" className="banner-video banner-mobvideo">
            <source src={`${process.env.REACT_APP_LOANPROGRAMS_URL}${videoSourceMobile}`} loading="eager" type="video/mp4" />
          </video>
        )
      )}

      <Container>
        <div className="row justify-content-center">
          <div className="col-12 text-center banner-content">
            {headings && (
              <div className="banner-heading-group">
                {headings.title && (
                  <h1 className="banner-title">{parse(headings.title)}</h1>
                )}
                {headings.subtitle && (
                  <h2 className="banner-subtitle">{parse(headings.subtitle)}</h2>
                )}
              </div>
            )}

            {bannerDesign && (
              <div className="banner-design">
                <img
                  src={`${process.env.REACT_APP_LOANPROGRAMS_URL}${selectBannerDesign}`}
                  alt="Banner Design"
                  className=""
                />
              </div>
            )}
 
            <div className="banner-cta-buttons">
              {ctaPrimaryButton && (
                <Button onClick={handleApplyNow} className="btn btn-primary">
                  {parse(ctaPrimaryButton.label)}
                </Button>
              )}
           {ctaSecondaryButton && (
              <Button  onClick={() => {window.location.href = ctaSecondaryButton.url;}} className="btn btn-primary requestcallback-btn">
                {parse(ctaSecondaryButton.label)}
              </Button>
            )}
              </div>

            {bannerText && (
              <div className="banner-bottom-text">{parse(bannerText)}</div>
            )}
          </div>
        </div>
      </Container>

      {/* BorrowerLeadFormModal - with default prop values */}
      <BorrowerLeadFormModal
        formHeading={formHeading}
        loanPurpKeyword={loanPurpKeyword}
        noteRate={noteRate}
        offerTerm={offerTerm}
        showLeadFormModal={showLeadFormModal}
        onHide={handleCloseLeadFormModal}
      />
    </div>
  );
}

export default Banner;